import React from "react";

// DIN EN ISO 7010 E003 — Erste-Hilfe-Symbol (white cross on green square).
// Used as the standard first-aid pictogram in Germany & EU.
export const FirstAidSymbol = ({ className = "", size = 56 }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        width={size}
        height={size}
        className={className}
        aria-label="Erste-Hilfe-Symbol"
    >
        <rect width="100" height="100" rx="12" fill="#0F8040" />
        <path
            d="M40 18h20v22h22v20H60v22H40V60H18V40h22V18z"
            fill="#ffffff"
        />
    </svg>
);
